export default "__VITE_ASSET__CnE2xV$M__"